import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6483616e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invitedd dropdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-plus" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Invite ")
const _hoisted_4 = { class: "invitedd__dropdown__content d-flex flex-column justify-content-between" }
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Send invitation")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_button = _resolveComponent("action-button")!
  const _component_avatar = _resolveComponent("avatar")!
  const _component_workspace_list_item = _resolveComponent("workspace-list-item")!
  const _component_workspace_list = _resolveComponent("workspace-list")!
  const _component_workspace_dropdown = _resolveComponent("workspace-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_action_button, {
      id: "invite-ab",
      class: "invitedd__toggle bg-white dropdown-toggle",
      "data-bs-toggle": "dropdown",
      "data-bs-auto-close": "false",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inviteDD = !_ctx.inviteDD))
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_workspace_dropdown, {
      show: _ctx.inviteDD,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inviteDD = false)),
      title: "Invite to board",
      class: "invitedd__dropdown"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
              type: "search",
              class: "form-control",
              placeholder: "Email address or name",
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.debouncedSearch && _ctx.debouncedSearch(...args)))
            }, null, 544), [
              [_vModelText, _ctx.search]
            ]),
            (_ctx.search.length)
              ? (_openBlock(), _createBlock(_component_workspace_dropdown, {
                  key: 0,
                  ref: "dl_dropdown",
                  "header-classes": "d-none",
                  "divider-classes": "d-none",
                  class: "pt-3 border",
                  show: _ctx.searchedMembers.length ? true : false,
                  "root-styles": {
              width: '100%',
              minWidth: '100%',
              maxHeight: '200px',
              overflowY: 'scroll'
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_workspace_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedMembers, (mem) => {
                          return (_openBlock(), _createBlock(_component_workspace_list_item, {
                            key: mem._id,
                            onClick: ($event: any) => (_ctx.handleChooseMember(mem))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_avatar, {
                                name: mem.name
                              }, null, 8, ["name"]),
                              _createElementVNode("span", null, _toDisplayString(mem.email), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["show"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_workspace_list, {
            class: "mt-2 flex-grow-1",
            style: {"height":"200px","overflow-y":"scroll"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chosenMembers, (mem) => {
                return (_openBlock(), _createBlock(_component_workspace_list_item, {
                  key: mem._id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_avatar, {
                      name: mem.name
                    }, null, 8, ["name"]),
                    _createElementVNode("span", _hoisted_6, " (" + _toDisplayString(mem.email) + ") ", 1),
                    _createElementVNode("i", {
                      class: "bi bi-x",
                      onClick: _withModifiers(($event: any) => (_ctx.handleRemoveChosen(mem)), ["stop"])
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_action_button, {
            onClick: _ctx.handleSendInvitation,
            disabled: _ctx.chosenMembers.length < 1 || _ctx.disabledSendInvite,
            class: "btn-primary-1 justify-content-center border-0 px-3 py-2"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}